export const quotationListRouter = [
  {
    path: `/QuotationList`,
    name: `QuotationList`,
    redirect: `/main`,
    hidden: true,
    component: () => import('@/views/Home'),
    children: [
      {
        path: '/main',
        name: 'HomePage',
        meta: {
          activename: 'HomePage'
        },
        component: () => import('@/views/quotationlist/QuotationList')
      }
    ]
  }
];
